import { render, staticRenderFns } from "./create-form.vue?vue&type=template&id=66d28fd1&"
import script from "./create-form.vue?vue&type=script&lang=js&"
export * from "./create-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports